import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToTryOn, removeFromTryOn, selectSelectedForTryOn } from '../redux/slices/clothingItemsSlice';
import { useTryOnMode } from './useTryOnMode';

/**
 * Hook for handling clothing item selection for try-on
 */
export const useTryOnSelection = () => {
  const dispatch = useDispatch();
  const { isVirtualMode } = useTryOnMode();
  const selectedForTryOn = useSelector(selectSelectedForTryOn);

  const toggleItemForTryOn = useCallback((item) => {
    if (!isVirtualMode) return false;

    const isSelected = selectedForTryOn.includes(item.id);
    
    if (isSelected) {
      dispatch(removeFromTryOn(item.id));
    } else {
      dispatch(addToTryOn(item));
    }
    
    return !isSelected;
  }, [dispatch, isVirtualMode, selectedForTryOn]);

  const isItemSelectedForTryOn = useCallback((itemId) => {
    return selectedForTryOn.includes(itemId);
  }, [selectedForTryOn]);

  return {
    toggleItemForTryOn,
    isItemSelectedForTryOn,
    canSelectForTryOn: isVirtualMode
  };
};

export default useTryOnSelection;